<template>
    <span v-bind:class="statusClass" class="status-dot"></span>
</template>
<script>
export default {
    name: 'StatusDot',
    props: {
        active: Boolean,
    },
    computed: {
        statusClass() {
            return {
                'status-on': this.active,
                'status-off': !this.active,
            };
        },
    },
};
</script>
<style scoped>
.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
}
.status-on {
    background-color: var(--v-success-base);
}
.status-off {
    background-color: #999;
}
</style>